<template>
  <div id="eu-layout" :class="{
    mobile: isMobileDevice,
    'eu-tabs-fixed': theme.showTabsBar && theme.fixedTabsBar,
    ['eu-layout_'+theme.layout]: true
  }">
    <!-- Header Nav -->
    <header-nav-bar @themeconfig="themeConfigShow=true" />
    <!-- Top Menu -->
    <!-- <top-menu /> -->
    <!-- container -->
    <div id="app-container">
      <!-- main -->
      <main id="app-container__main">
        <app-container-tabs v-if="theme.showTabsBar" />
        <!-- 头部 -->
        <app-container-header v-if="curRouteMeta.showHeader" />
        <!-- 内容区域 -->
        <app-container-body />
        <!-- 底部 -->
        <app-container-footer v-if="curRouteMeta.showFooter" />
      </main>
    </div>

    <!-- 主题配置 -->
    <theme-config :show.sync="themeConfigShow" />
    <!-- 回到顶部 -->
    <el-backtop ref="elBackTop" :target="backTopSelector"></el-backtop>
  </div>
</template>

<script>
// import TopMenu from '@/layout/components/TopMenu/index.vue'
import ThemeConfig from '@/layout/components/ThemeConfig/index.vue'
import AppContainerBody from '@/layout/components/AppContainerBody/index.vue'
import AppContainerFooter from '@/layout/components/AppContainerFooter/index.vue'
import HeaderNavBar from '@/layout/components/HeaderNavBar/index.vue'
import AppContainerHeader from '@/layout/components/AppContainerHeader/index.vue'
import ResizeHandler from '@/layout/mixins/ResizeHandler'
import { mapGetters } from 'vuex'
import AppContainerTabs from '@/layout/components/AppContainerTabs/index.vue'

export default {
  name: 'TopLayout',
  mixins: [ResizeHandler],
  // TopMenu
  components: { AppContainerTabs, AppContainerHeader, HeaderNavBar, AppContainerFooter, AppContainerBody, ThemeConfig },
  data() {
    return {
      themeConfigShow: false
    }
  },
  computed: {
    ...mapGetters({
      routes: 'routes/routes',
      isMobileDevice: 'settings/isMobileDevice',
      theme: 'settings/theme'
    }),
    backTopSelector() {
      return '#app-container__main'
    },
    curRouteMeta() {
      const route = this.$route
      return route.meta || {}
    }
  }
}
</script>

<style lang='scss' scoped>
#eu-layout {
  position: relative;
}
#app-container {
  box-sizing: border-box;
  // padding-top: calc(var(--layout-header-nav-height) + var(--top-menu-height));
  padding-top: calc(var(--layout-header-nav-height));
}
#app-container__main {
  box-sizing: border-box;
  // height: calc(100vh - var(--layout-header-nav-height) - var(--top-menu-height));
  height: calc(100vh - var(--layout-header-nav-height) );
  width: 100vw;
  overflow: auto;

  display: flex;
  flex-direction: column;
}

// 固定TabsBar
.eu-tabs-fixed {
  #app-container__tabs {
    width: 100vw;
    position: fixed;
    // top: calc(var(--layout-header-nav-height) + var(--top-menu-height));
    top: calc(var(--layout-header-nav-height) );
    z-index: 10;
  }
  #app-container__main {
    // height: calc(100vh - var(--layout-header-nav-height) - var(--top-menu-height));
    height: calc(100vh - var(--layout-header-nav-height) );
    padding-top: 38px;
  }
}
</style>
